"use client";

import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "value", "indicatorClassName"];
var __jsx = React.createElement;
import * as React from "react";
import classNames from "classnames";
export var Progress = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value,
    indicatorClassName = _ref.indicatorClassName,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: classNames("relative h-4 w-full overflow-hidden rounded-full bg-secondary", className)
  }, props), /*#__PURE__*/React.createElement("div", {
    className: classNames("h-full w-full flex-1 bg-primary transition-all", indicatorClassName),
    style: {
      transform: "translateX(-".concat(100 - value, "%)")
    }
  }));
});
Progress.displayName = "Progress";